// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-013c443f] .center {\n  text-align: center;\n  margin-right: 0 !important;\n  margin-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
